import { useLazyQuery } from '@provision/graphql-client';
import { useCallback } from 'react';
import {
  GET_BULK_CONVERSATION_CONTEXT_FOR_MARKDOWN_EXPORT_QUERY,
  GetBulkConversationContextForMarkdownExportQuery,
  GetBulkConversationContextForMarkdownExportVariables,
} from './conversation-context.operations';

interface GetBulkConversationContextInput {
  conversationIds: string[];
  partnerId?: number | null;
}

export const useBulkConversationContext = () => {
  const [runBulkConversationContextQuery, { ...rest }] = useLazyQuery<
    GetBulkConversationContextForMarkdownExportQuery,
    GetBulkConversationContextForMarkdownExportVariables
  >(GET_BULK_CONVERSATION_CONTEXT_FOR_MARKDOWN_EXPORT_QUERY, {
    fetchPolicy: 'no-cache',
    context: {
      ttl: 0,
    },
  });

  const getBulkConversationContext = useCallback(
    ({ conversationIds, partnerId }: GetBulkConversationContextInput) => {
      const input: GetBulkConversationContextForMarkdownExportVariables['input'] = {
        conversationIds,
      };

      if (partnerId !== null && partnerId !== undefined) {
        input.partnerId = partnerId;
      }

      return runBulkConversationContextQuery({
        variables: {
          input,
        },
      });
    },
    [runBulkConversationContextQuery],
  );

  return {
    getBulkConversationContext,
    ...rest,
  };
};
